import RotatableImage from "./RotatableImage";

const DocumentViewer = ({ src, alt = "Document" }) => {
  if (!src) return null;

  const isPdf = src?.toLowerCase()?.includes(".pdf");

  return (
    <div>
      {isPdf ? (
        <div
          style={{
            width: "100%",
            height: "550px",
            backgroundColor: "#212121",
            borderRadius: "12px",
            overflow: "hidden",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: "12px",
            boxSizing: "border-box",
          }}
        >
          <div
            style={{
              width: "100%",
              height: "100%",
              backgroundColor: "#212121",
              borderRadius: "10px",
              overflow: "hidden",
              boxShadow: "0 2px 10px #212121",
              paddingTop: "30px",
              boxSizing: "border-box",
            }}
          >
            <iframe
              title="PDF Viewer"
              src={`https://docs.google.com/gview?embedded=true&url=${encodeURIComponent(
                src
              )}`}
              width="100%"
              height="100%"
              style={{
                border: "none",
                background: "transparent"
              }}
            />
          </div>
        </div>
      ) : (
        <RotatableImage src={src} alt={alt} />
      )}
    </div>
  );
};

export default DocumentViewer;